import * as React from "react";
import { Grid, TextField, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrder } from "../../../Redux/Customers/Order/Action";
import AddressCard from "../adreess/AdreessCard";
import { useState, useEffect } from "react";
import BackdropComponent from "../BackDrop/Backdrop";

export default function AddDeliveryAddressForm({ handleNext }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { auth } = useSelector((store) => store);
  const { order } = useSelector((state) => state);

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [address, setAddress] = useState({
    firstName: "",
    lastName: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    mobile: "",
  });

  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);

  // ✅ Real-time validation
  useEffect(() => {
    const newErrors = {};

    if (!address.firstName.trim()) newErrors.firstName = "First name is required";
    if (!address.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!address.streetAddress.trim()) newErrors.streetAddress = "Address is required";
    if (!address.city.trim()) newErrors.city = "City is required";
    if (!address.state.trim()) newErrors.state = "State is required";

    if (!address.zipCode.trim()) newErrors.zipCode = "Zip code is required";
    else if (!/^\d{6}$/.test(address.zipCode)) newErrors.zipCode = "Zip code must be 6 digits";

    if (!address.mobile.trim()) newErrors.mobile = "Phone number is required";
    else if (!/^\d{10}$/.test(address.mobile)) newErrors.mobile = "Phone number must be 10 digits";

    setErrors(newErrors);
    setIsValid(Object.keys(newErrors).length === 0);
  }, [address]);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isValid) return; // stop if invalid
    dispatch(createOrder({ address, jwt, navigate }));
    handleNext();
  };

  const handleCreateOrder = (item) => {
    const selectedAddr = {
      firstName: item.firstName?.trim(),
      lastName: item.lastName?.trim(),
      streetAddress: item.streetAddress?.trim(),
      city: item.city?.trim(),
      state: item.state?.trim(),
      zipCode: item.zipCode?.trim(),
      mobile: item.mobile?.trim(),
    };

    // Validate selected address
    const newErrors = {};
    if (!selectedAddr.firstName) newErrors.firstName = "First name required";
    if (!selectedAddr.lastName) newErrors.lastName = "Last name required";
    if (!selectedAddr.streetAddress) newErrors.streetAddress = "Address required";
    if (!selectedAddr.city) newErrors.city = "City required";
    if (!selectedAddr.state) newErrors.state = "State required";
    if (!selectedAddr.zipCode || !/^\d{6}$/.test(selectedAddr.zipCode)) newErrors.zipCode = "Zip code invalid";
    if (!selectedAddr.mobile || !/^\d{10}$/.test(selectedAddr.mobile)) newErrors.mobile = "Phone number invalid";
    console.log("newErrors", newErrors)
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    dispatch(createOrder({ address: selectedAddr, jwt, navigate }));
    handleNext();
  };

  return (
    <>
      {order.loading && <BackdropComponent open={order.loading} />}
      <Grid container spacing={4}>
        {/* Existing addresses */}
        <Grid item xs={12} lg={5}>
          <Box className="border rounded-md shadow-md h-[30.5rem] overflow-y-scroll">
            {auth.user?.addresses.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedAddress(item)}
                className="p-5 py-7 border-b cursor-pointer"
              >
                <AddressCard address={item} />
                {selectedAddress?.id === item.id && (
                  <Button
                    sx={{ mt: 2 }}
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={() => handleCreateOrder(item)}
                  >
                    Deliver Here
                  </Button>
                )}
              </div>
            ))}
          </Box>
        </Grid>

        {/* New address form */}
        <Grid item xs={12} lg={7}>
          <Box className="border rounded-md shadow-md p-5">
            <form onSubmit={handleSubmit} noValidate>
              <Grid container spacing={3}>
                {[
                  { id: "firstName", label: "First Name" },
                  { id: "lastName", label: "Last Name" },
                  { id: "streetAddress", label: "Address", multiline: true, rows: 4 },
                  { id: "city", label: "City" },
                  { id: "state", label: "State/Province/Region" },
                  { id: "zipCode", label: "Zip / Postal code" },
                  { id: "mobile", label: "Phone Number" },
                ].map((field) => (
                  <Grid item xs={12} sm={field.id === "streetAddress" ? 12 : 6} key={field.id}>
                    <TextField
                      required
                      id={field.id}
                      name={field.id}
                      label={field.label}
                      fullWidth
                      multiline={field.multiline || false}
                      rows={field.rows || 1}
                      value={address[field.id]}
                      onChange={handleChange}
                      error={!!errors[field.id]}
                      helperText={errors[field.id] || ""}
                    />
                  </Grid>
                ))}

                <Grid item xs={12}>
                  <Button
                    sx={{ padding: ".9rem 1.5rem" }}
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={!isValid} // ✅ disable until valid
                  >
                    Deliver Here
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
